import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../theming/jssTypes';
import * as moment from 'moment';
import { useTranslation } from 'react-i18next';
import Modal from 'src/design-system/components/atoms/Modal/Modal';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';

const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: '300px',
    boxShadow: theme.shadow.sm,
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: theme.spacing[2],
    },
  },
  table: {
    marginLeft: theme.spacing[0],
  },
});

const InvoiceListModal = (props) => {
  const { t } = useTranslation();
  const generateDataColumns = () => {
    const columnData: any = [
      {
        title: t('S.No.'),
        key: 'index',
        render: (text, record, index) => index + 1,
        width: '12%',
      },
      {
        title: t('Invoice No.'),
        key: 'invoiceNumber',
        width: '22%',
        render: (text, record) => record['invoiceNumber'] ?? '',
      },
      {
        title: t('Invoice Amount'),
        key: 'invoiceValue',
        width: '22%',
        render: (text, record) => record['invoiceValue'] ?? '',
      },
      {
        title: t('Invoice Date'),
        key: 'invoiceDate',
        width: '22%',
        render: (text, record) =>
          record['invoiceDate']
            ? moment(record['invoiceDate']).format('DD MMM YYYY')
            : '',
      },
      {
        title: t('EWB Number'),
        key: 'ewbNumber',
        width: '22%',
        render: (text, record) => record['ewbNumber'] ?? '',
      },
    ];
    return columnData;
  };

  const { isVisible, classes, invoiceList } = props;
  const header = 'Invoice List';

  return (
    <Modal
      title={t(header)}
      width="500px"
      visible={isVisible}
      footer={null}
      onCancel={() => props.handleModalClose(false)}
      destroyOnClose
    >
      <div className={classes.tableContainer}>
        <FixedHeaderTable
          locale={{ emptyText: t('No Invoices') }}
          pagination={false}
          columns={generateDataColumns()}
          dataSource={invoiceList}
          className={classes.table}
        />
      </div>
    </Modal>
  );
};

export default withStyles(styles, { injectTheme: true })(InvoiceListModal);
